module.exports = __webpack_public_path__ + "static/novo-cream-rolls3-8ba3915df71d896616e7040ebeddf645.jpg";